import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { RouterContext } from "../router";
import { Text } from "@corpuscomplete/web-ui/components/text";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  errorComponent: ({ error }) => (
    <div className="flex-1 items-center justify-center">
      <Text variant="h1">Error</Text>
      <Text variant="sm">{error.message}</Text>
    </div>
  ),
});
